function setCookie(name, value, hours) {
  const d = new Date();
  d.setTime(d.getTime() + (hours * 60 * 60 * 1000));
  const expires = "expires=" + d.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

function getCookie(name) {
  const cookieName = name + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookieArray = decodedCookie.split(';');
  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(cookieName) === 0) {
      return cookie.substring(cookieName.length, cookie.length);
    }
  }
  return "";
}

function getRandomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function updateEyeCount() {
  const productId = "9644646269266";
  const cookieName = "eyeCount_" + productId;
  let eyeCount = getCookie(cookieName);

  if (eyeCount === "") {
    eyeCount = getRandomNumber(5, 20); // Change range to 5-20
    setCookie(cookieName, eyeCount, 1); // Set cookie for 1 hour
  }

  document.getElementById("eyeCount").textContent = eyeCount;
  document.getElementById("notification-count").textContent = eyeCount;
}

// Call the function when the page loads
updateEyeCount();



